<template>
  <div class="looplay_page">
    <div class="lp_1" :style="{ backgroundImage: 'url(' + imgSiteNum6 + ')' }">
      <div class="halababy_loop_1">
        <p class="halababy_loop_2" v-html="testList[0]"></p>
        <p class="halababy_loop_3" v-html="testList[1]">
        </p>
        <a class="halababy_loop_4" :href="appUrl">
          {{ testList[22] }}
        </a>
      </div>
    </div>
    <div class="lp_2">
      <p class="lp_2_1 lp_title">{{ testList[2] }}</p>
      <p class="lp_2_2 lp_desc">
        {{ testList[3] }}
      </p>
      <div class="lp_2_3">
        <img class="lp_2_d1" :src="imgSiteNum0" />
        <img class="lp_2_d2" :src="imgSiteNum1" />
        <div class="lp_2_d3 lp_2_d3d" @mouseover="mouseOver(0)" :style="{background: bg0.background}">
          <p class="lp_2_d6 lp_2_dti">{{ testList[4] }}</p>
          <p class="lp_2_d61 lp_2_dde">{{ testList[5] }}</p>
          <p class="lp_2_d7 lp_2_dde">{{ testList[6] }}</p>
        </div>
        <div class="lp_2_d4 lp_2_d3d" @mouseover="mouseOver(1)" :style="{background: bg1.background}">
          <p class="lp_2_d8 lp_2_dti">{{ testList[7] }}</p>
          <p class="lp_2_d81 lp_2_dde">{{ testList[8] }}</p>
          <p class="lp_2_d9 lp_2_dde">{{ testList[9] }}</p>
        </div>
        <div class="lp_2_d5 lp_2_d3d" @mouseover="mouseOver(2)" :style="{background: bg2.background}">
          <p class="lp_2_d10 lp_2_dti">{{ testList[10] }}</p>
          <p class="lp_2_d11 lp_2_dde">{{ testList[11] }}</p>
          <p class="lp_2_d11 lp_2_dde">{{ testList[12] }}</p>
        </div>
      </div>
    </div>
    <div class="lp_3">
      <div
        class="lp_3_1"
        :style="{ backgroundImage: 'url(' + imgSiteNum2 + ')' }"
      ></div>
      <div class="lp_3_2">
        <p class="lp_3_21">{{ testList[13] }}</p>
        <div class="lp_3_22">
          <div class="lp_3_221">
            <p class="lp_3_2211">{{ testList[14] }}</p>
            <p class="lp_3_2212">{{ testList[15] }}</p>
          </div>
          <div class="lp_3_222 lp_3_222l"></div>
          <div class="lp_3_221 lp_3_222l">
            <p class="lp_3_2211">{{ testList[16] }}</p>
            <p class="lp_3_2212">{{ testList[17] }}</p>
          </div>
          <div class="lp_3_222 lp_3_222l"></div>
          <div class="lp_3_221 lp_3_222l">
            <p class="lp_3_2211">{{ testList[18] }}</p>
            <p class="lp_3_2212">{{ testList[19] }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="lp_4">
      <div
        class="lp_4_111"
        id="lp_4_111bg"
        :style="{ backgroundImage: 'url(' + imgSiteNum3 + ')' }"
      >
        <p class="lp_4_111b">{{ testList[23] }}</p>
        <p class="lp_4_111bd">
          {{ testList[24] }}
        </p>
        <img class="lp_4_113" :src="imgSiteNum5" />
      </div>
      <div id="lunbotu" class="lp_4_1">
        <div
          v-for="(item, index) in baokGames"
          :class="'lp_4_11ss' + (index + 1)"
          :id="'lp_4_11ss' + (index + 1)"
          :key="item.id"
        >
          <div
            class="lp_4_112"
            :style="{ backgroundImage: 'url(' + imgSiteNum4 + ')' }"
          >
            <div style="width:774px;height:470px;overflow: hidden;border-radius: 30px;">
              <img class="lp_4_112i" :src="item.image" />
            </div>
            
          </div>
          <div class="lp_4_116">
            <div class="lp_4_1161">
              <img
                class="lp_4_11611"
                width="112px"
                height="112px"
                :src="item.icon"
              />
              <div class="lp_4_11612">
                <p class="lp_4_116121">{{ item.name }}</p>
                <div class="lp_4_116122">{{ item.type }}</div>
              </div>
            </div>
            <div class="lp_4_1162">
              {{ item.description }}
            </div>
            <div class="lp_4_1163">
              <div class="lp_4_11631">
                <p class="lp_4_116311">{{ testList[25] }}</p>
                <p class="lp_4_116312">{{ item.download }}</p>
              </div>
              <div class="lp_4_11632">
                <p class="lp_4_116311">{{ testList[26] }}</p>
                <p class="lp_4_116312">
                  TOP0{{ index + 1 }}.{{ item.ranking }}天
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lp_4_2" id="lp_4_2id">
        <div
          v-for="(item, index) in baokGames"
          :key="item.id"
          class="lp_4_21 lp_4_21pr"
          :style="index == 0 ? 'background-color:rgba(10, 177, 255, 1)' : ''"
        ></div>
      </div>
    </div>
    <div class="lp_5">
      <p class="lp_5_1">{{ testList[20] }}</p>
      <p class="lp_5_2">{{ testList[21] }}</p>
      <div class="lp_5_3">
        <gameBlock :gameBlocks="gameBlocks"></gameBlock>
      </div>
    </div>
  </div>
</template>

<script>
import gameBlock from "./component/gameBlock";
export default {
  name: "looplay_page",
  props: ["langType"],
  watch: {
    langType: function (type) {
      this.changeLang(type);
      this.getGames(type);
      this.getBaoKuan(type);
    },
  },
  components: {
    gameBlock,
  },
  created() {
    //当前轮播索引
    this.currentLunBo = 0;
    //爆款游戏定时器
    this.baoktimer = null;

    var lan = navigator.language;
    if(lan == 'zh-CN'){
      this.changeLang('zh')
      this.getGames('zh')
      this.getBaoKuan('zh')
    }else{
      this.changeLang('en')
      this.getGames('en')
      this.getBaoKuan('en')
    }

    // this.changeLang(this.$i18n.locale);
    // this.getGames(this.$i18n.locale);
    // this.getBaoKuan(this.$i18n.locale);
    this.getImg();
    this.mouseOver(0)
    this.getLooplay();
  },
  destroyed: function () {
    clearInterval(this.baoktimer);
  },
  mounted: function () {
    this.handleScroll();
  },
  methods: {
    getBaoKuan(language) {
      this.$post("/halababy/loofox/game", { type: 0, num: 5, baoK: 1 }).then((res) => {
        let games = new Array();
        for (let i = 0; i < res.data.length; i++) {
          let types = res.data[i]["types"].split("|")[0];
          let typesEn = res.data[i]["typesEn"] == null ? '':res.data[i]["typesEn"].split("|")[0];
          let game = {
            id: res.data[i]["id"],
            name: res.data[i]["name"],
            image: this.$ip + res.data[i]["image"],
            description: res.data[i]["description"],
            icon: this.$ip + res.data[i]["icon"],
            download: res.data[i]["download"],
            ranking: res.data[i]["ranking"],
            type: types,
          };
          if(language == 'en'){
            game.name = res.data[i]["nameEn"];
            game.description = res.data[i]["descriptionEn"];
            game.type = typesEn;
          }
          games.push(game);
        }
        this.baokGames = games;
      });
    },
    handleScroll() {
      //--开始动画
      let box = document.getElementById("lp_4_111bg");
      box.className = "lp_4_111dh";
      let selects = document.getElementById("lp_4_2id").children;
      //获取每一块
      let lunb = document.getElementById("lunbotu").children;
      // selects[this.currentLunBo].style.backgroundColor =
      //   "rgba(10, 177, 255, 1)";
      for (let i = 0; i < lunb.length; i++) {
        lunb[i].className = "lp_4_11ssdh" + (i + 3);
      }
      //--结束开始动画

      //开启轮播定时动画
      this.baoktimer = setInterval(() => {
        let baoks = document.getElementById("lunbotu").children;
        let startSetIndex = this.currentLunBo;
        for (let i = 0; i < baoks.length; i++) {
          //设置动画
          baoks[startSetIndex].className = "lp_4_11ssdh" + (i + 2);
          //当startSetIndex等于baoks.length就得设置0开始的索引元素了
          startSetIndex += 1;
          if (startSetIndex == baoks.length) {
            startSetIndex = 0;
          }
          //选择条的背景颜色全部清空
          selects[startSetIndex].style.backgroundColor = "";
        }
        this.currentLunBo += 1;
        if (this.currentLunBo == baoks.length) {
          this.currentLunBo = 0;
        }
        selects[this.currentLunBo].style.backgroundColor =
          "rgba(10, 177, 255, 1)";

          
      }, 5000);
    },
    gameDev() {
    },
    getLooplay(){
      this.$post("/halababy/loofox/getlooplay").then((res) => {
        this.appUrl = res.data;
      });
    },
    getGames(language) {
      this.$post("/halababy/loofox/game", { type: 0, num: 6 }).then((res) => {
        let games = new Array();
        for (let i = 0; i < res.data.length; i++) {
          let game = {
            id: res.data[i]["id"],
            name: res.data[i]["name"],
            description: res.data[i]["description"],
            icon: this.$ip + res.data[i]["icon"],
            image: this.$ip + res.data[i]["image"],
          };
          if(language == 'en'){
            game.name = res.data[i]["nameEn"];
            game.description = res.data[i]["descriptionEn"];
          }
          games.push(game);
        }
        this.gameBlocks = games;
      });
    },
    getImg() {
      this.$post("/halababy/loofox/img", { pageNum: 3 }).then((res) => {
        this.imgSiteNum0 = this.$ip + res.data[0]["imgUrl"];
        this.imgSiteNum1 = this.$ip + res.data[1]["imgUrl"];
        this.imgSiteNum2 = this.$ip + res.data[2]["imgUrl"];
        this.imgSiteNum3 = this.$ip + res.data[3]["imgUrl"];
        this.imgSiteNum4 = this.$ip + res.data[4]["imgUrl"];
        this.imgSiteNum5 = this.$ip + res.data[5]["imgUrl"];
        this.imgSiteNum6 = this.$ip + res.data[6]["imgUrl"];
      });
    },
    //修改语言
    changeLang(type) {
      this.$post("/halababy/loofox/text", { pageNum: 3 }).then((res) => {
        if (type == "zh") {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["content"]);
          }
          this.testList = arr;
        } else {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["contentEn"]);
          }
          this.testList = arr;
        }
      });
    },
    mouseOver(index){
      if(index == 0){
        this.bg0 = {
          background: 'url(' + require('../assets/loop/loop3.png') + ')',
        }
      }else{
        this.bg0 = {
          background: '',
        }
      }
      if(index == 1){
        this.bg1 = {
          background: 'url(' + require('../assets/loop/loop3.png') + ')',
        }
      }else{
        this.bg1 = {
          background: '',
        }
      }
      if(index == 2){
        this.bg2 = {
          background: 'url(' + require('../assets/loop/loop3.png') + ')',
        }
      }else{
        this.bg2 = {
          background: '',
        }
      }
    }
  },
  data() {
    return {
      appUrl: '',
      bg0: this.bg0,
      bg1: this.bg1,
      bg2: this.bg2,
      testList:[],
      baokGames: this.baokGames,
      gameBlocks: this.gameBlocks,
      imgSiteNum0: this.imgSiteNum0,
      imgSiteNum1: this.imgSiteNum1,
      imgSiteNum2: this.imgSiteNum2,
      imgSiteNum3: this.imgSiteNum3,
      imgSiteNum4: this.imgSiteNum4,
      imgSiteNum5: this.imgSiteNum5,
      imgSiteNum6: this.imgSiteNum6,
    };
  },
};
</script>

<style>
.looplay_page {
  width: 100%;
}
.lp_title {
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #181818;
}
.lp_desc {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  margin: 30px auto 30px auto;
}
.lp_1 {
  width: 100%;
  height: 600px;
  position: relative;
  margin: auto;
}
.halababy_loop_2 {
  font-size: 64px;
  font-family: sucaijishikufangti;
  font-weight: 400;
  color: #ffffff;
  text-shadow: 0px 4px 6px rgba(14, 176, 223, 0.2);
}
.halababy_loop_3 {
  padding-top: 30px;
  padding-bottom: 40px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 34px;
  text-align: left;
}
.halababy_loop_4 {
  text-decoration: none;
  display: inline-block;
  margin-top: 40px;
  padding: 15px 50px;
  background-color: #ffffff;
  border-radius: 27px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #0ab1ff;
  border: none;
  cursor: pointer;
}
.lp_2 {
  width: 100%;
  margin: 30px auto 0 auto;
  overflow: hidden;
}
.lp_2_3 {
  width: 1200px;
  height: 700px;
  position: relative;
  margin: auto;
}
.lp_2_d1 {
  position: absolute;
  top: 30px;
  right: -600px;
  z-index: 1;
}
.lp_2_d2 {
  position: absolute;
  top: 30px;
  right: -470px;
  z-index: 0;
}
.lp_2_d3d {
  width: 500px;
  height: 252px;
  position: absolute;
  text-align: left;
}
.lp_2_d3d:hover {
  /* background: url("../assets/loop/loop3.png") no-repeat; */
}
.lp_2_d3 {
  top: -30px;
  z-index: 1;
}
.lp_2_d4 {
  top: 202px;
  z-index: 1;
}
.lp_2_d5 {
  top: 432px;
  z-index: 1;
}
.lp_2_dti {
  display: inline-block;
  margin-top: 70px;
  margin-left: 60px;
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
}
.lp_2_dde {
  margin-left: 60px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  line-height: 36px;
}
.lp_3 {
  width: 1200px;
  margin: 30px auto 40px auto;
  display: flex;
  justify-content: space-between;
}

.lp_3_1 {
  width: 519px;
  height: 431px;
}
.lp_3_2 {
  margin-top: 110px;
}
.lp_3_21 {
  font-size: 44px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
  text-align: left;
}
.lp_3_22 {
  display: flex;
  text-align: left;
  margin-top: 30px;
}
.lp_3_221 {
  width: 180px;
}
.lp_3_222 {
  width: 0px;
  border: 1px dashed #A2A2A2;
}
.lp_3_222l {
  margin-left: 30px;
}
.lp_3_2211 {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
}
.lp_3_2212 {
  margin-top: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  line-height: 24px;
}
.lp_4 {
  width: 100%;
  margin: auto;
  position: relative;
  overflow: hidden;
}
#lunbotu {
  width: 1920px;
  height: 710px;
  position: relative;
}
/* 动画class */
.lp_4_11ssdh2 {
  width: 1500px;
  height: 710px;
  position: absolute;
  top: 0;
  left: 0px;
  animation: move2 3s ease 0s 1 alternate forwards;
  -webkit-animation: move2 3s ease 0s 1 alternate forwards;
}
.lp_4_11ssdh3 {
  width: 1500px;
  height: 710px;
  position: absolute;
  top: 0;
  left: 1500px;
  animation: move3 3s ease 0s 1 alternate forwards;
  -webkit-animation: move3 3s ease 0s 1 alternate forwards;
}
.lp_4_11ssdh4 {
  width: 1500px;
  height: 710px;
  position: absolute;
  top: 0;
  left: 3000px;
  animation: move4 3s ease 0s 1 alternate forwards;
  -webkit-animation: move4 3s ease 0s 1 alternate forwards;
}
.lp_4_11ssdh5 {
  width: 1500px;
  height: 710px;
  position: absolute;
  top: 0;
  left: 4500px;
  animation: move5 3s ease 0s 1 alternate forwards;
  -webkit-animation: move5 3s ease 0s 1 alternate forwards;
}
.lp_4_11ssdh6 {
  width: 1500px;
  height: 710px;
  position: absolute;
  top: 0;
  left: 6000px;
  animation: move6 3s ease 0s 1 alternate forwards;
  -webkit-animation: move6 3s ease 0s 1 alternate forwards;
}
.lp_4_11ssdh7 {
  width: 1500px;
  height: 710px;
  position: absolute;
  top: 0;
  left: 7500px;
  animation: move7 3s ease 0s 1 alternate forwards;
  -webkit-animation: move7 3s ease 0s 1 alternate forwards;
}
.lp_4_11ss1 {
  width: 1500px;
  height: 710px;
  position: absolute;
  top: 0;
  left: 0px;
}
.lp_4_11ss2 {
  width: 1500px;
  height: 710px;
  position: absolute;
  top: 0;
  left: 1500px;
}
.lp_4_11ss3 {
  width: 1500px;
  height: 710px;
  position: absolute;
  top: 0;
  left: 3000px;
}
.lp_4_11ss4 {
  width: 1500px;
  height: 710px;
  position: absolute;
  top: 0;
  left: 4500px;
}
.lp_4_11ss5 {
  width: 1500px;
  height: 710px;
  position: absolute;
  top: 0;
  left: 6000px;
}
.lp_4_111 {
  position: absolute;
  z-index: 0;
  top: 0;
  left: -1319px;
  width: 1319px;
  height: 540px;
}
/* 背景出现动画 */
/*调用动画 */
/* animation：动画名称 花费时间 运动曲线 何时开始 播放次数 是否反方向 */
.lp_4_111dh {
  position: absolute;
  z-index: 0;
  top: 0;
  left: -1319px;
  width: 1319px;
  height: 540px;
  background-image: url("../assets/loop/loop5.png");
  animation: move 2s ease 0s 1 alternate forwards;
  -webkit-animation: move 2s ease 0s 1 alternate forwards;
}
/* 声明动画 关键帧 @keyframes 动画名称{} */
@keyframes move {
  from {
    left: -1319px;
  }
  to {
    left: 0px;
  }
}
@-webkit-keyframes move {
  from {
    left: -1319px;
  }
  to {
    left: 0px;
  }
}
@-ms-keyframes move {
  from {
    left: -1319px;
  }
  to {
    left: 0px;
  }
}
@keyframes move2 {
  from {
    left: 0px;
  }
  to {
    left: -1500px;
  }
}
@-webkit-keyframes move2 {
  from {
    left: 0px;
  }
  to {
    left: -1500px;
  }
}
@-ms-keyframes move2 {
  from {
    left: 0px;
  }
  to {
    left: -1500px;
  }
}
@keyframes move3 {
  from {
    left: 1500px;
  }
  to {
    left: 0px;
  }
}
@-webkit-keyframes move3 {
  from {
    left: 1500px;
  }
  to {
    left: 0px;
  }
}
@-ms-keyframes move3 {
  from {
    left: 1500px;
  }
  to {
    left: 0px;
  }
}
@keyframes move4 {
  from {
    left: 3000px;
  }
  to {
    left: 1500px;
  }
}
@-webkit-keyframes move4 {
  from {
    left: 3000px;
  }
  to {
    left: 1500px;
  }
}
@-ms-keyframes move4 {
  from {
    left: 3000px;
  }
  to {
    left: 1500px;
  }
}
@keyframes move5 {
  from {
    left: 4500px;
  }
  to {
    left: 3000px;
  }
}
@-webkit-keyframes move5 {
  from {
    left: 4500px;
  }
  to {
    left: 3000px;
  }
}
@-ms-keyframes move5 {
  from {
    left: 4500px;
  }
  to {
    left: 3000px;
  }
}
@keyframes move6 {
  from {
    left: 6000px;
  }
  to {
    left: 4500px;
  }
}
@-webkit-keyframes move6 {
  from {
    left: 6000px;
  }
  to {
    left: 4500px;
  }
}
@-ms-keyframes move6 {
  from {
    left: 6000px;
  }
  to {
    left: 4500px;
  }
}
@keyframes move7 {
  from {
    left: 7500px;
  }
  to {
    left: 6000px;
  }
}
@-webkit-keyframes move7 {
  from {
    left: 7500px;
  }
  to {
    left: 6000px;
  }
}
@-ms-keyframes move7 {
  from {
    left: 7500px;
  }
  to {
    left: 6000px;
  }
}
.lp_4_111b {
  position: absolute;
  top: 63px;
  left: 360px;
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 30px;
}
.lp_4_111bd {
  position: absolute;
  top: 126px;
  left: 360px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
}

.lp_4_112 {
  position: absolute;
  z-index: 10;
  top: 170px;
  left: 10px;
  width: 869px;
  height: 559px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lp_4_112i{
  /* border-radius: 30px; */
  height: 100%;
}
.lp_4_113 {
  position: absolute;
  z-index: 2;
  top: 85px;
  left: 1150px;
}
.lp_4_114 {
  position: absolute;
  z-index: 6;
  top: 328px;
  left: 900px;
}
.lp_4_115 {
  position: absolute;
  z-index: 6;
  top: 400px;
  left: 1050px;
}
.lp_4_116 {
  width: 679px;
  height: 479px;
  position: absolute;
  z-index: 5;
  top: 240px;
  left: 750px;
  background-image: url("../assets/loop/loop12.png");
}
.lp_4_1161 {
  padding-top: 80px;
  padding-left: 150px;
  display: flex;
}
.lp_4_11612 {
  margin-left: 20px;
}
.lp_4_116121 {
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
  line-height: 36px;
}
.lp_4_116122 {
  margin-top: 30px;
  width: 120px;
  height: 40px;
  background-image: url("../assets/loop/loop11.png");
  line-height: 40px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #0ab1ff;
  line-height: 36px;
}
.lp_4_1162 {
  width: 470px;
  height: 72px;
  padding-top: 20px;
  padding-left: 150px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  line-height: 28px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lp_4_1163 {
  text-align: left;
  padding-top: 20px;
  padding-left: 150px;
  display: flex;
}
.lp_4_11631 {
  width: 250px;
}
.lp_4_116311 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #292929;
  line-height: 36px;
}
.lp_4_116312 {
  margin-top: 10px;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #181818;
  line-height: 36px;
}
.lp_4_2 {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lp_4_21 {
  width: 56px;
  height: 8px;
  background-color: rgba(231, 231, 239, 1);
  cursor: pointer;
}
/* .lp_4_21:hover {
  background-color: rgba(10, 177, 255, 1);
} */
.lp_4_21pr {
  margin-left: 10px;
}
.lp_5 {
  width: 1200px;
  margin: 30px auto 30px auto;
}
.lp_5_1 {
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #181818;
}
.lp_5_2 {
  margin: 20px auto 40px auto;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
}
.lp_5_3 {
  margin-top: 20px;
}
.lp_6 {
  width: 1200px;
  height: 500px;
  margin: 30px auto 0 auto;
  background-color: #12729e;
}
.halababy_loop_1{
  position: absolute;
  top: 119px;
  left: 360px;
  text-align: left;
}
.lp_4_11611{
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/looplay.vue